import React, {Component} from 'react'
import moment from 'moment';
import {connect} from 'react-redux'
import action from '../helper/action'
import do_action from '../action'
import {Form, FormGroup} from '../component/form/form'
import {Portlet, PortletHead, PortletBody, PortletFooter, PortletAlert} from '../component/widget/portlet'
import {
  Link,
  withRouter
} from "react-router-dom"
import apis from '../helper/api'
import localdata from '../helper/localdata'
import config from '../helper/config'
import swal from 'sweetalert'
import util from '../helper/util'
import request from 'superagent'
import {history} from '../helper/history'
import {DatePicker, DatePickerInput} from 'rc-datepicker'

let photo_default = "../../swipe/assets/app/media/img/users/default.jpg"

class MasterDownloadAgent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            flag_processing: false,
            status_downline_sel: 'ACTIVE',
            status_agent_sel: 'ACTIVE'
        }
        this.on_btn_submit = this.on_btn_submit.bind(this)
    }

    componentDidMount() {
        this.props.update_current_page('manage-agent')
    }


    on_select_change(e) {
        this.setState({[e.target.id]: e.target.value})
    }

    on_error(err) {
        if (err.code == 2006) {
            localdata.clear_data().then((res) => {
                history.replace('/login')
            }).catch((err) => {
                util.log("error: ", err)
            })
        } else {
            let msg = "Error: " + err.code
            if (err.message !== undefined) {
                msg = err.message
            }
            swal("Ups!", msg, "warning")
        }
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_btn_submit() {
        if (this.state.flag_processing) return
        let body = {
            "session_id" : this.props.session,
            "child_status" : this.state.status_downline_sel,
            "agent_status" : this.state.status_agent_sel
        }
        let self = this
        let url = apis.download_agent_list
        this.setState({flag_processing: true})
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            if (payload.results !== null) {
                                window.open(payload.results);
                            } else {
                                swal("Error!", "Data tidak dapat di download. Hubungi Admin untuk informasi lebih lanjut")
                            }
                        } else {
                            self.on_error(payload.error)
                        }
                    } else {
                        swal("Error!", res.statusCode, "warning")
                    }
                }
                self.setState({flag_processing: false})
            })
    }

    render() {
        let self = this
        return (
            <div className="row">
                <div className="col-md-12">
                    <Portlet>
                        <PortletHead headTxt={"Download Daftar Agent dan Downline"} />
                        <PortletBody>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div style={{}}>
                                        <div className="form-group m-form__group row">
                                            <label htmlFor="example-text-input" className="col-2 col-form-label" style={{}}>
                                                Status Downline
                                            </label>
                                            <div className="col-10" style={{margin: 'auto 0'}}>
                                                <select className="form-control m-input" id="status_downline_sel" value={this.state.status_downline_sel} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                    <option value="ACTIVE"> ACTIVE </option>
                                                    <option value="REGISTERING"> REGISTERING </option>
                                                    <option value="SUSPENDED"> SUSPENDED </option>
                                                    <option value="DEACTIVATED"> DEACTIVATED </option>
                                                    <option value="UNAPPROVED"> UNAPPROVED </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="form-group m-form__group row">
                                            <label htmlFor="example-text-input" className="col-2 col-form-label" style={{}}>
                                                Status Agent
                                            </label>
                                            <div className="col-10" style={{margin: 'auto 0'}}>
                                                <select className="form-control m-input" id="status_agent_sel" value={this.state.status_agent_sel} onChange={(e) => this.on_select_change(e)} style={{}}>
                                                    <option value="ACTIVE"> ACTIVE </option>
                                                    <option value="REGISTERING"> REGISTERING </option>
                                                    <option value="SUSPENDED"> SUSPENDED </option>
                                                    <option value="DEACTIVATED"> DEACTIVATED </option>
                                                    <option value="UNAPPROVED"> UNAPPROVED </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="m-portlet__foot m-portlet__foot--fit m-portlet__no-border" style={{marginTop:'40px'}}>
                                        <div className="m-form__actions">
                                            <div className="row">
                                                <div className="col-7">
                                                    <button type="reset" 
                                                        onClick={this.on_btn_submit} 
                                                        className={this.state.flag_processing ? 'btn btn-accent m-btn m-btn--air m-btn--custom m-loader m-loader--light m-loader--right' : 'btn btn-accent m-btn m-btn--air m-btn--custom'}>
                                                        Request Download
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </PortletBody>
                    </Portlet>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    update_current_page:  val => dispatch(do_action(action.ACTION_UPDATE_CURRENT_PAGE, val)),
    loading: val => dispatch(do_action(action.ACTION_LOADING), val)
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(MasterDownloadAgent)



// WEBPACK FOOTER //
// ./src/component/magent_download_agent.js